import { useLanguage } from "../../../../../stores/LanguageStore";
import { useState } from "react";
import { ActionIcon, Button, Tooltip } from "@mantine/core";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { updateProspect } from "../../../../../api/PRMAPI";
import {
  useLeadsContainerStore,
  useLeadsSheetStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";

const MarkAsNew = ({ current, closeMenu, containerId, inSheet, isMobile }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const setNewsCount = useLeadsStore((s) => s.setNewsCount);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const updateContainerItem = useLeadsContainerStore(
    (s) => s.updateContainerItem
  );

  const handleClick = () => {
    setLoading(true);
    return updateProspect({ id: current.id, new_reply: true })
      .then(() => {
        setLoading(false);
        closeMenu?.();
        if (inSheet) {
          updateContainerItem(currentContainer?.id, current.id, {
            new_reply: true,
          });
          setCurrent({ ...current, new_reply: true });
        } else {
          updateContainerItem(containerId, current.id, { new_reply: true });
        }
        if (current?.new_reply === false) {
          setNewsCount(useLeadsStore.getState().newsCount + 1);
        }
      })
      .finally(() => setLoading(false));
  };

  if (inSheet) {
    if (isMobile) {
      return (
        <Button
          variant="light"
          color="primary"
          px={"sm"}
          onClick={handleClick}
          loading={loading}
        >
          {current?.new_reply ? (
            <IconStarFilled size={18} />
          ) : (
            <IconStar size={18} />
          )}
        </Button>
      );
    }
    return (
      <Tooltip label={lang.prm.mark_as_new}>
        <ActionIcon
          onClick={handleClick}
          variant={current?.new_reply ? "filled" : "light"}
          size={38}
          radius={"xl"}
          loading={loading}
        >
          {current?.new_reply ? (
            <IconStarFilled size={22} />
          ) : (
            <IconStar size={22} />
          )}
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Button
      onClick={handleClick}
      variant="subtle"
      loading={loading}
      leftSection={<IconStar size={18} />}
      justify="start"
    >
      {lang.prm.mark_as_new}
    </Button>
  );
};

export default MarkAsNew;
